import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PurchaseInward from '@/types/table/purchaseInward';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PurchaseInwardData extends PurchaseInward {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PurchaseInwardController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PurchaseInwardData>>(API_CONTEXT + '/app/purchaseInward/list', params, httpOptions);
  }
  static dataListByUser(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PurchaseInwardData>>(API_CONTEXT + '/app/purchaseInward/dataListByUser', params, httpOptions);
  }

   static dataList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PurchaseInwardData>>(API_CONTEXT + '/app/purchaseInward/dataList', params, httpOptions);
  }

  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PurchaseInwardData>(API_CONTEXT + '/app/purchaseInward/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/purchaseInward/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/purchaseInward/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/purchaseInward/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/purchaseInward/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/purchaseInward/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/purchaseInward/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/purchaseInward/deleteBatch', params, httpOptions);
  }
  static listByUserId(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PurchaseInwardData>>(API_CONTEXT + '/app/purchaseInward/listByUserId', params, httpOptions);
  }
}
